import { ArrowLeft, ShieldX } from "lucide-react";
import { FC } from "react";
import { Link } from "react-router-dom";
import Header from "../ui/Header";

interface SopAccessDeniedProps {
  message?: string;
  showHeader?: boolean;
}

const SopAccessDenied: FC<SopAccessDeniedProps> = ({
  message = "You don't have permission to access this SOP.",
  showHeader = true,
}) => {
  const content = (
    <div className="h-full w-full flex items-center justify-center">
        <div className="text-center max-w-md px-4">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-amber-500/10 border border-amber-500/20 mb-4">
            <ShieldX className="w-8 h-8 text-amber-400" />
          </div>
          <h2 className="text-xl font-semibold text-white mb-2">
            Access Denied
          </h2>
          <p className="text-slate-400 mb-6">{message}</p>
          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <Link
              to="/sop-dashboard"
              className="inline-flex items-center justify-center gap-2 px-4 py-2.5 rounded-lg font-medium text-sm bg-blue-600 hover:bg-blue-500 text-white transition-colors"
            >
              <ArrowLeft className="w-4 h-4" />
              Back to SOPs
            </Link>
          </div>
        </div>
      </div>
  );

  if (!showHeader) {
    return (
      <div className="loading-state flex items-center justify-center min-h-[calc(100vh-5rem)] mt-20">
        {content}
      </div>
    );
  }

  return (
    <div className="h-screen w-full flex flex-col">
      <Header />
      {content}
    </div>
  );
};

export default SopAccessDenied;
